import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// 1. Define styles
const sidebarStyles = `
  .nav-link {
    transition: all 0.2s;
    position: relative;
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
  }

  .nav-link:hover,
  .nav-link:focus {
    background: #264882;
    color: #fff !important;
    text-decoration: none;
  }

  .sidebar-active,
  .sidebar-active i,
  .nav-link.sidebar-active {
    font-weight: bold !important;
    color: #fff !important;
    background: #093FB4 !important; 
  }
`;

function capitalizeWords(str) {
  if (!str) return "User";
  return str
    .split(" ")
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join(" ");
}

function Sidebars({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [username, setUsername] = useState(localStorage.getItem("name") || "");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");

  useEffect(() => {
    const handleUserDataChanged = () => {
      setUsername(localStorage.getItem("name") || "");
      setEmail(localStorage.getItem("email") || "");
    };

    handleUserDataChanged();
    window.addEventListener("userDataChanged", handleUserDataChanged);
    window.addEventListener("storage", handleUserDataChanged);

    return () => {
      window.removeEventListener("userDataChanged", handleUserDataChanged);
      window.removeEventListener("storage", handleUserDataChanged);
    };
  }, [location.key]);

  const handleSignOut = () => {
    localStorage.clear();
    window.dispatchEvent(new Event("userDataChanged"));
    navigate("/");
  };

  // Simplified Active Link Logic (No Admin checks)
  const getLinkClass = (path) => {
    if (location.pathname === path || location.pathname.startsWith(path + "/")) {
      return "fw-bold text-white sidebar-active";
    }
    return "text-white";
  };

  let displayName = "User";
  if (username && username.trim()) {
    displayName = capitalizeWords(username.trim());
  } else if (email) {
    displayName = email.split("@")[0].replace(/^([a-zA-Z])/, (c) => c.toUpperCase());
  }

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <style>{sidebarStyles}</style>

      {/* SIDEBAR: Fixed Position */}
      <div
        className="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark"
        style={{
          width: "280px",
          height: "100vh",
          position: "fixed", // Keeps sidebar frozen on the left
          left: 0,
          top: 0,
          zIndex: 1000,
          overflowY: "auto"
        }}
      >
        <Link
          to="/Homepage"
          className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        >
          <div
            className="d-flex align-items-center justify-content-center me-2 rounded"
            style={{
              width: "40px",
              height: "40px",
              background: "#093FB4",
              color: "white",
              fontWeight: "bold",
              fontSize: "1.2rem",
              flexShrink: 0
            }}
          >
            TL
          </div>
          <span className="fs-4">Terra LandX</span>
        </Link>
        <hr />
        
        <ul className="nav nav-pills flex-column mb-auto">
          {/* Dashboard */}
          <li>
            <Link
              to="/Homepage"
              className={`nav-link ${getLinkClass("/Homepage")}`}
            >
              <i className="bi bi-house me-2"></i>
              Dashboard
            </Link>
          </li>

          {/* GIS Map (Previously Organizations) */}
          <li className="nav-item mt-1">
            <Link
              to="/Map"
              className={`nav-link ${getLinkClass("/Map")}`}
            >
              <i className="bi bi-map me-2"></i>
              GIS Map
            </Link>
          </li>

          {/* Building List (Previously Flight Record) */}
          <li className="nav-item mt-1">
             <Link
               to="/BuildingList"
               className={`nav-link ${getLinkClass("/BuildingList")}`}
             >
               <i className="bi bi-list-ul me-2"></i>
               Building List
             </Link>
           </li>
        </ul>

        <hr />
        
        {/* Profile Dropdown */}
        <div className="dropdown">
          <a
            href="#"
            className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
            id="dropdownUser1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-person-circle me-2" style={{ fontSize: "32px", lineHeight: "32px" }}></i>
            <strong>{displayName}</strong>
          </a>
          <ul className="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
            <li>
              <Link className="dropdown-item" to="/Profile">
                Profile
              </Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button className="dropdown-item" onClick={handleSignOut}>
                Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>


      <div style={{ marginLeft: "280px", minHeight: "100vh" }}>
        {children}
      </div>
    </div>
  );
}

export default Sidebars;